var _defs, _clipPath, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFtCloseMob(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 14 14"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "FT_close_mob_svg__a",
    d: "M-674 973.9h-3v4h3v12h5v-12h3.6l.4-4h-4v-1.7c0-1 .2-1.3 1.1-1.3h2.9v-5h-3.8c-3.6 0-5.2 1.6-5.2 4.6v3.4z"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "FT_close_mob_svg__b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FT_close_mob_svg__a",
    overflow: "visible"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#FT_close_mob_svg__b)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "FT_close_mob_svg__c",
    d: "M-894-2086.1H549v4196H-894z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#1A1818"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.614 14.029L8.442 9.857l1.415-1.415 4.171 4.172zM12.6 0L7 5.6 1.4 0 0 1.4 5.6 7 0 12.6 1.4 14 14 1.4z"
  }))));
}
export default SvgFtCloseMob;